<template>
    <div class="root" v-loading="loading">
        <router-link to="/" replace>
            <div class="header">
                <div class="iconfont back-icon">&#xe624;</div>
                <div class="headertxt">
                    完善信息
                </div>
            </div>
        </router-link>

        <div class="questiondiv">
            <div style="text-align:center; margin:12px 0 22px 0; font-size: 18px; font-weight: bold;">
                完善信息
            </div>

            <div style="border-bottom:1px #eee solid;">
            
                <div class="inputitem">
                    <div class="inputlabel"><span>*</span>姓名</div>
                    <div class="inputdiv">
                        <input v-model="nickname" type="text" maxlength="10" placeholder="请输入姓名" />
                    </div>
                </div>
                <div class="inputitem">
                    <div class="inputlabel"><span>*</span>手机号</div>
                    <div class="inputdiv">
                        <input v-model="username" type="number" maxlength="11" @input="limitLength"
                            placeholder="请输入手机号" />
                    </div>
                </div>
                <div class="inputitem" v-show="false">
                    <div class="inputlabel"><span>*</span>密码</div>
                    <div class="inputdiv">
                        <input v-model="password" type="password" maxlength="12" placeholder="请输入6~12位密码" />
                    </div>
                </div>
                <div class="inputitem">
                    <div class="inputlabel"><span>*</span>单位</div>
                    <div class="inputdiv">
                        <input v-model="company" type="text" maxlength="30" placeholder="请输入单位" />
                    </div>
                </div>

            </div>
            <div class="errmsg" v-if="showerr1">请输入正确的手机号</div>
            <div class="errmsg" v-if="showerr2">{{errmsg2}}</div>
            <div class="errmsg" v-if="showerr3">{{errmsg3}}</div>

            <div style="margin:30px 0;">
                <el-button type="danger" style="width:100%; " @click="submit">确定</el-button>
            </div>
            <!-- <div style="text-align:center;">
                如果您已经有账号了，请直接登录.
            </div>
            <router-link to="/login">
            <div style="text-align: center; margin:10px;">
                <el-button type="primary" plain icon="el-icon-edit-outline">登录</el-button>
            </div>
            </router-link> -->
        </div>


    </div>
</template>

<script>

import axios from 'axios'
import sha1 from "sha1";
import router from '../../router';

export default {
    name: 'wenda',
    data: function () {
        return {
            radio: '1',
            list: [],
            password: '123456',
            nickname:'',
            company:'',
            username: '',
            showerr1: false,
            showerr2: false,
            errmsg2:'',
            showerr3:false,
            errmsg3:'',
            dialogVisible: false,
            loading:false
        }
    },
    components: {

    },
    methods: {
        limitLength() {
            if (this.username.length > 11) {
                this.username = this.username.slice(0, 11)
            }
        },

        submit: function () {

            console.log(this.username, this.password)
            
            if(this.nickname==null || this.nickname==undefined ||this.nickname==''){
                this.errmsg2 = "请输入姓名";
                this.showerr2=true;
                     return;
            }else{
                this.showerr2=false;
            }

            if(this.username==null || this.username==undefined || this.username.length!=11){
                this.showerr1=true;
                     return;
            } else {
                var reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/
                if (this.username === '' || !reg.test(this.username)) {
                     this.showerr1=true;
                     return;
                }else{
                    this.showerr1=false;
                }
            }
            if(this.password==null || this.password==undefined ||this.password==''){
                this.errmsg2 = "请输入密码";
                this.showerr2=true;
                     return;
            }else{
                if (this.password.length < 6 || this.password.length > 12) {
                    this.errmsg2 = "请输入6~12位密码";
                    this.showerr2 = true;
                    return;
                }else{
                this.showerr2=false;
                }
            }
            if(this.company==null || this.company==undefined ||this.company==''){
                this.errmsg2 = "请输入单位";
                this.showerr2=true;
                     return;
            }else{
                this.showerr2=false;
            }

            this.login();
        },
        login() {
            this.loading=true;
            console.log("register");
            
            var passwordhash = this.password;
            axios.post('/api/Login/register',
                {
                    nickname:this.nickname,
                    company:this.company,
                    username: this.username,
                    password: passwordhash
                }
            )
                .then(this.getHomeInfoSucc)
        },
        getHomeInfoSucc(res) {
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                var userJson = {
                    uid:res.uid,
                    token:res.token,
                    nickname:res.nickname,
                    company:res.company
                }
                localStorage.setItem('userJson', JSON.stringify(userJson));
                this.showerr3=false;
var that=this;
                this.$message({
                    message: '登录成功',
                    type: 'success',
                    duration:2000,
                    onClose: function () {
            that.loading=false;
                        router.replace('/')
                    }
                });

                // 
            }else{
            this.loading=false;
                this.errmsg3 = res.Msg;
                this.showerr3=true;
            }
        },


    },
    mounted() {
         this.username = localStorage.getItem('logintel')
    }
}
</script>
<style> 
.el-message{
max-width: 90% !important;
}
</style>
<style scoped >
.root {
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
}

.header {
    padding: .24rem;
    display: flex;
}

.headertxt {
    flex: 1;
    text-align: center;
    color: #fff;
    margin-right: 20px;
    line-height: 20px;
}

.back-icon {
    font-size: .4rem;
    color: #fff;
}

.questiondiv {
    /* height: calc(100vh - 20vh - 44px); */
    overflow-y: scroll;
    background: #fff;
    width: 90vw;
    margin: 10vh auto 20px auto;
    padding: 12px;
    border-radius: 5px;
    box-sizing: border-box;
}

.questiontitle {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
}

.option {
    font-size: 18px;
    margin-bottom: 10px;
    border: 1px #f1f1f1 solid;
    padding: 10px;
    line-height: 22px;
}

.option.selected {
    border-color: #BA0109;
    color: #BA0109;
    text-decoration: line-through;
}

.option.selected2 {

    border-color: green;
    color: green;

}

.mybtns {
    width: 80vw;
    display: flex;
    margin: 20px auto;
}

.btnpre {
    flex: 1;
    margin-right: 10px;
    color: #e6a23c;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    border: 1px solid #e6a23c;
}

.btnnext {
    flex: 1;
    margin-left: 10px;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    background: #e6a23c;
}

.btnsubmit {
    flex: 1;
    margin-left: 10px;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 1000px;
    background: #67c23a;
}

.errmsg {
    color: red;
    margin: 5px auto 10px auto;
}

.inputitem {
    display: flex;
    border: 1px #eee solid;
    border-bottom: none;
}

.inputlabel span {
    color: red;
}

.inputlabel {
    margin: 10px;
    line-height: 21px;
}

.inputdiv {
    margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/register/register.vue